import dayjs from 'dayjs';

/* eslint-disable import/prefer-default-export */
export function formatDate(date, format = 'DD/MM/YYYY') {
  return dayjs(date).format(format);
}
